require('./ruleCondition.i18n.json');
require('./ruleCondition.tpl.html');
require('./ruleConditionController.js');
require('./ruleConditionValue/ruleConditionValueComponent.js');
require('./binaryCondition/binaryConditionComponent.js');

const RuleConditionComponent = {
    templateUrl: '/common/rule/ruleCondition/ruleCondition.tpl.html',
    controller: 'ruleConditionController',
    bindings: {
        ruleCondition: '<',
        onDeleteSubcondition: '&',
        onToggleNegation: '&',
        isUnaryCondition: '<',
        canUserManageFormRules: '<',
        defaultFormTemplateUniqueName:'<'
    }
};

angular.module('ums')
    .component('uiRuleCondition', RuleConditionComponent);
